<template>
  <div class="download">
    <template v-if="isWx&&isAndroid">
      <div class="main zyMain">
        <div class="zy"><img src="@/assets/image/downZy.png"/></div>
        <img src="@/assets/image/download-logo.png"/>
        <p>发现好店，分享美好生活！</p>
      </div>
    </template>
    <template v-else>
      <div class="main">
        <img src="@/assets/image/download-logo.png"/>
        <p>发现好店，分享美好生活！</p>
        <a href="javascript:;" @click="openApp">立即下载探店吃喝玩乐</a>
      </div>
    </template>
  </div>
</template>
<script>
import {androidUrl} from '@/api'
export default {
  data() {
    return {
      isAndroid: null,
      andiorUrl: "",
      isWx: false
    }
  },
  created(){
    const u = navigator.userAgent
    if(u.indexOf('Android') > -1 || u.indexOf('Linux') > -1){
      this.isAndroid = true
    } else {
      this.isAndroid = false
    }
    const ua = navigator.userAgent.toLowerCase()
    if(ua.match(/MicroMessenger/i)=="micromessenger") {  
      this.isWx = true
    } else {  
      this.isWx = false
    }  
  },
  methods: {
    // 点击打开app
    openApp() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        window.location.href = 'tandian://';
        setTimeout(function(){
          let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
          if(typeof hidden =="undefined" || hidden ==false){
            //App store下载地址
            window.location.href = "https://apps.apple.com/app/id1527402524";
          }
        }, 1000);
        return false;
        // var loadDateTime = new Date();
        // window.location.href = "tandian://"; //schema链接或者universal link
        // window.setTimeout(function() {
        //   //如果没有安装app,便会执行setTimeout跳转下载页
        //   var timeOutDateTime = new Date();
        //   if (timeOutDateTime - loadDateTime < 5000) {
        //     window.location = "https://apps.apple.com/app/id1527402524"; //ios下载地址
        //   } else {
        //     window.close();
        //   }
        // }, 500);
      } else if (navigator.userAgent.match(/android/i)) {
        try {
          window.location = "tandian://"; //schema链接或者universal linky
          window.setTimeout(()=> {
            if (this.andiorUrl === '' || this.andiorUrl === undefined) {
              this.getAndiorUrl()
            } else {
              window.location.href = this.andiorUrl //android下载地址
            }
          }, 500);
        } catch (e) {
          console.log(e);
        }
      }
    },
    getAndiorUrl () {
      androidUrl().then(res => {
        const { code, data } = res;
        if (code === '200') {
          this.shareMessage(data)
          this.andiorUrl = data.packageUrl
          window.location.href = this.andiorUrl //android下载地址
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.download {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background: url('../assets/image/download-bg.png') no-repeat bottom center;
  background-size: 100% auto;
  .main{
    text-align: center;
    margin: 2.346667rem auto;
    font-size: .5rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    &.zyMain{
      margin: 4.2rem auto;
      .zy{
        position: absolute;
        top: .4rem;
        right: .6rem;
      }
    }
    p{
      margin-top: 0.4rem;
    }
    a{
      width: 5.84rem;
      height: 1.226667rem;
      line-height: 1.226667rem;
      display: inline-block;
      border: 1px solid #F3474A;
      opacity: 1;
      border-radius: 50px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #F3474A;
      margin-top: 1.226667rem;
      
    }
  }
}
</style>